<p class="mb-1">
  {{
    answer.value_label
      ? answer.value_label + ' ' + (answer.value | date: dateFormat)
      : (answer.value | date: dateFormat)
  }}
</p>
